(function() {
    $(document).ready(function() {
        $('.c24Carousel').c24Carousel();
    });
})();
